import React, { useState, useContext, useEffect, useRef } from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import Customers from '../components/Customers';
import Seeds from '../components/Seeds';
import Trays from '../components/Trays';
import Media from '../components/Media';
import Solution from '../components/Solution';
import Farm from '../components/Farm';
// import Overheads from '../components/Overheads';
import { trackFeature } from '../utils/analytics';
import { SnackbarContext } from '../SnackbarContext';

// A simple TabPanel component for MUI tabs.
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`management-tabpanel-${index}`}
      aria-labelledby={`management-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1, mt: 2}}>{children}</Box>}
    </div>
  );
}



// Accessibility props helper.
function a11yProps(index) {
  return {
    id: `management-tab-${index}`,
    'aria-controls': `management-tabpanel-${index}`,
  };
}

const tabKeys = ['customers', 'inventory', 'farm'];

function Management() {
  const [tabValue, setTabValue] = useState(0);
  const { showSuccess, showError } = useContext(SnackbarContext);

  // keep track if we've already fired once
  const hasLoaded = useRef(false);

  useEffect(() => {
    if (!hasLoaded.current) {
      // skip on first render
      hasLoaded.current = true;
      return;
    }
    // only fire when the user actually switches tabs
    trackFeature('page_view', {
      page_path: `/management/${tabKeys[tabValue]}`,
      tab: tabKeys[tabValue],
    });
  }, [tabValue]);

  const handleTabChange = (_, newValue) => {
    setTabValue(newValue);
  };


  return (
    <Box
      sx={{
        maxWidth: '95%',
        backgroundColor: (theme) => theme.palette.background.default,
        color: (theme) => theme.palette.text.primary,
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        margin: '0 auto',
        padding: '0px',
        
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: (theme) => theme.palette.background.default,
          zIndex: -1,
        },
      }}
    >
      <Box sx={{ 
        margin: '0 auto 0 auto' }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          textColor="inherit"
          variant="standard"
          centered
          sx={{
            color: (theme) => theme.palette.tertiary.light,
            '& .MuiTabs-indicator': {
              backgroundColor: (theme) => theme.palette.warning.light,
            },
            '& .MuiTabs-flexContainer': {
              gap: 2,
            },
          }}
        >
          <Tab
            label="Customers"
            sx={{
              color: (theme) => theme.palette.primary.light,
              minWidth: 140,
              px: 2.5,
              '&.Mui-selected': {
                color: (theme) => theme.palette.warning.main,
              },
            }}
            {...a11yProps(0)}
          />
          <Tab
            label="Inventory"
            sx={{
              color: (theme) => theme.palette.primary.light,
              minWidth: 140,
              px: 2.5,
              '&.Mui-selected': {
                color: (theme) => theme.palette.warning.main,
              },
            }}
            {...a11yProps(1)}
          />
          {/* <Tab
            label="Costs & Overheads"
            sx={{
              color: (theme) => theme.palette.primary.light,
              '&.Mui-selected': {
                color: (theme) => theme.palette.warning.main,
              },
            }}
            {...a11yProps(2)}
          /> */}
                    <Tab
            label="Farm"
            sx={{
              color: (theme) => theme.palette.primary.light,
              minWidth: 140,
              px: 2.5,
              '&.Mui-selected': {
                color: (theme) => theme.palette.warning.main,
              },
            }}
            {...a11yProps(2)}
          />
        </Tabs>
        
      </Box>

      <TabPanel value={tabValue} index={0}>
        <Customers setError={showError} setSuccess={showSuccess} />
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <Seeds setError={showError} setSuccess={showSuccess} />
        <Trays setError={showError} setSuccess={showSuccess} />
        <Media setError={showError} setSuccess={showSuccess} />
        <Solution setError={showError} setSuccess={showSuccess} />
      </TabPanel>

      {/* <TabPanel value={tabValue} index={2}>
        <Overheads setError={showError} setSuccess={showSuccess} />
      </TabPanel> */}

      <TabPanel value={tabValue} index={2}>
        <Farm setError={showError} setSuccess={showSuccess} />
      </TabPanel>
    </Box>

  );

}

export default Management;

function isSubscriptionActive(userData) {
  if (!userData || !userData.accessExpires) {
    // If no expiration is set, assume active
    return true;
  }
  const now = new Date();
  const expires = userData.accessExpires.toDate
    ? userData.accessExpires.toDate()
    : new Date(userData.accessExpires);
  return now <= expires;
}
